import { render } from "./ToastMessage.vue?vue&type=template&id=1f3df02e"
import script from "./ToastMessage.vue?vue&type=script&lang=js"
export * from "./ToastMessage.vue?vue&type=script&lang=js"
script.render = render

export default script